export const productJsonProps = {
	barcode: 'product.barcode',
	brand: 'product.brand',
	buyable: 'product.isBuyable',
	category: 'product.categories',
	gtinId: 'product.gtinId',
	published: 'product.isPublished',
	itemNumber: 'product.itemNumber',
	productId: 'product.omniItemId',
	image: 'product.imageUrls',
	name: 'product.description',
	url: 'product.pdURL',
	id: 'product.id',
	_id: '_id',
	vendorNumber: 'product.vendorNumber',
	description: 'product.description',
	modelId: 'product.modelId',
	status: 'product.status',
	startDate: 'product.startDate',
	ivm: 'product.ivm',
	division: 'product.merchandisingHierarchy.divisionDescription',
};

export const productElasticSearchMatchFields = [
	productJsonProps.productId,
	productJsonProps.name,
	productJsonProps.description,
	productJsonProps.modelId,
	productJsonProps.itemNumber,
	productJsonProps.vendorNumber,
	productJsonProps._id,
	productJsonProps.id,
	productJsonProps.barcode,
	productJsonProps.ivm,
	productJsonProps.gtinId,
	productJsonProps.buyable,
	// this field is provided as a filter key for products.
	// so that "show results for..." groupBy type appears as a first option(which takes user to results page) on search dropdown.
	'name',
];

//drawer constants
export const productsRemoveDrawerMsg = 'Unlink All Products';
export const productsRemoveConfirmationMsg = 'Are you sure you want to Unlink all products from the ';
export const assetQuestionMarkTxt = ' asset ?';
export const productsDrawerRemoveBtnTxt = 'Yes, Unlink All Products';

//manage asset
export const manageAssetUnlinkAllProductsSuccessMsg = 'All products unlinked from ';
export const manageAssetUnlinkAllProductsErrorMsg = 'Error unlinking products from asset ';

export const manageAssetLinkProductSuccessMsg = 'Product added to ';
export const manageAssetLinkProductErrorMsg = 'Error linking product to ';

export const manageAssetUnLinkProductSuccessMsg = 'Product unlinked from ';
export const manageAssetUnLinkProductErrorMsg = 'Error unlinking product ';

export const lowesDomainUrl = 'https://www.lowes.com';
export const lowesImageUrl = 'https://mobileimages.lowes.com';

// Product UI fields
export const productPanelFields = {
	productId: 'Omni ID / Product ID',
	barcode: 'Barcode',
	ivm: 'Ivm',
	lastUpdatedAt: 'Last updated at',
	isBuyable: 'Buyable',
	productName: 'Product Name',
	corgisId: 'Corgis ID',
};
